import { render } from "./OftalmologiaForm.vue?vue&type=template&id=e335c1da&scoped=true"
import script from "./OftalmologiaForm.vue?vue&type=script&lang=js"
export * from "./OftalmologiaForm.vue?vue&type=script&lang=js"

import "./OftalmologiaForm.vue?vue&type=style&index=0&id=e335c1da&scoped=true&lang=scss"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e335c1da"]])

export default __exports__